export function randomSelect<T>(arr: T[], num: number): T[] {
  const copiedArr = arr.slice()
  // 抽出したい数より抽出対象の配列の数が少ない場合、配列の数を抽出数とする
  const selectedNum = copiedArr.length < num ? copiedArr.length : num

  const result: T[] = []

  for (let i = 0; i < selectedNum; i++) {
    const randomIndex = Math.floor(Math.random() * copiedArr.length)
    result.push(copiedArr[randomIndex])
    // 選ばれた要素は次に選ばれないように削除
    copiedArr.splice(randomIndex, 1)
  }
  return result
}